import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { inputCls } from "./ui";

export const AiImageGenerator = ({ title, keyword, hasImage, onDone }) => {
  const [details, setDetails] = useState("");
  const [model, setModel] = useState("gemini-3.1-flash-image-preview");
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    if ((title || "").trim().length < 3) return toast.error("Add a post title first so the AI knows what to draw");
    setBusy(true);
    try {
      const { data } = await api.post("/admin/ai/image", { title: title.trim(), keyword, details, model }, { timeout: 120000 });
      onDone(data);
      toast.success("AI featured image ready");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="mt-4 rounded-xl border border-[#D4AF37]/20 bg-[#D4AF37]/[0.04] p-4" data-testid="ai-image-generator">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#D4AF37]"><Sparkles size={14} /> Generate with AI</p>
      <p className="mt-1 text-xs text-zinc-500">Creates a 16:9 black &amp; gold image from your title and keyword.</p>
      <textarea rows={2} value={details} onChange={(e) => setDetails(e.target.value)} maxLength={500} placeholder="Optional: describe the scene (e.g. cricket stadium at night, golden ball)"
        className={`${inputCls} mt-3 text-sm`} data-testid="ai-image-details" />
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <select value={model} onChange={(e) => setModel(e.target.value)} className={`${inputCls} !w-auto text-xs`} data-testid="ai-image-model">
          <option value="gemini-3.1-flash-image-preview">Nano Banana (fast)</option>
          <option value="gemini-3-pro-image-preview">Nano Banana Pro (best)</option>
        </select>
        <button type="button" onClick={generate} disabled={busy} data-testid="ai-image-generate"
          className="inline-flex items-center gap-2 rounded-full bg-gradient-to-b from-[#F3D77A] to-[#D4AF37] px-4 py-2 text-xs font-bold uppercase tracking-wider text-black transition-transform hover:-translate-y-0.5 disabled:opacity-60">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />}
          {busy ? "Generating… (up to 1 min)" : hasImage ? "Regenerate image" : "Generate image"}
        </button>
      </div>
    </div>
  );
};
